export type CanonicalOfferStatus = 'draft' | 'published' | 'closed'

type Translate = (key: string) => string

const OFFER_STATUS_TRANSLATION_KEYS: Record<CanonicalOfferStatus, string> = {
  draft: 'offers.status.draft',
  published: 'offers.status.published',
  closed: 'offers.status.closed',
}

export const isCanonicalOfferStatus = (status: string): status is CanonicalOfferStatus => (
  Object.prototype.hasOwnProperty.call(OFFER_STATUS_TRANSLATION_KEYS, status)
)

export const getLocalizedOfferStatus = (status: string, t: Translate): string => {
  const normalized = status.trim().toLowerCase()
  if (!isCanonicalOfferStatus(normalized)) return ''
  return t(OFFER_STATUS_TRANSLATION_KEYS[normalized])
}
